import styled from '@app/styled';
import { spacing } from '@app/theme';

export const Container = styled.div`
    margin-top: ${spacing(4)};
    display: grid;
    gap: ${spacing(4)};
`;
